module.exports = __webpack_public_path__ + "static/media/英文校对.dad1a335.png";